import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { After2017HeaderLabels } from '../../../../../core/interface/issues-2017-2018.interface';
import { AFTER_2017_HEADER } from '../../../../../core/constants/issues-2017-2018.constants';

@Component({
  selector: 'app-after-2017-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './after-2017-header.html',
  styleUrl: './after-2017-header.scss',
})
export class After2017Header implements OnInit, OnChanges {
  @Input() screenVisible: string = '';
  @Input() gridColumnsTemplate: string = '';
  @Input() headerColumns: After2017HeaderLabels[] = [];
  headers: After2017HeaderLabels[] = AFTER_2017_HEADER;

  ngOnInit(): void {
    this.after2017TemplateHeader;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['screenVisible']) {
      this.screenVisible = changes['screenVisible'].currentValue;
    }
  }

  get after2017TemplateHeader(): string {
    return this.gridColumnsTemplate;
  }

  get displayColumns(): After2017HeaderLabels[] {
    return this.headerColumns;
  }
}
